/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, Col, Row, Select } from 'antd';
import Search from 'antd/es/input/Search';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import styles from './styles.module.scss';

const StyledSelect = styled(Select)`
  && {
    width: 100%;
  }
  .ant-select-selection-item {
    line-height: 37px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 36px !important;
    color: #9e9e9e;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;
const StyledCheckedbox = styled(Checkbox)`
  .ant-checkbox-inner {
    background-color: #fff;
    border: 1px solid #d9d9d9;
  }
  .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: #4096ff;
    border-color: transparent;
  }
`;
const StyledMultipleSelect = styled(Select)`
  && {
    width: 100%;
  }
  .ant-select-selector {
    height: 40px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 40px !important;
    color: #9e9e9e;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
`;
const StyleSearch = styled(Search)`
  && {
    width: 100%;
  }
  .ant-input {
    height: 40px !important;
  }
  .ant-btn {
    background: #478bbc;
    height: 40px !important;
    border: none;
  }
`;
interface SearchComponentProps {
  setUrl: any;
  setPage: any;
  searchCriteriaList: Array<{ label: string; value: string }>;
  baseUrl: string;
  disabledSearch: boolean;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  setUrl,
  setPage,
  disabledSearch,
  baseUrl,
  searchCriteriaList,
}: SearchComponentProps) => {
  const [dropdownOption, setDropdownOption] = useState<{
    [index: string]: Array<{ value: string; label: string }>;
  }>({});
  const [OPTIONS, setOPTIONS] = useState<Array<any>>([]);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState<string>();
  const [profileStatus, setProfileStatus] = useState(true);
  const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
  const navigation = useNavigate();

  const handleSearchByKeyWord = (value: any, event: any) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page-number', '1');
    navigation({ search: searchParams.toString() });
    setUrl(baseUrl + `?` + 'search_key' + '=' + value);
    setPage(1);
    // setSelectedItems([]);
  };

  return (
    <>
      <Row style={{ marginLeft: 16 }} gutter={[16, 16]} align={'middle'}>
        <Col span={24}>
          <StyleSearch
            disabled={disabledSearch}
            enterButton={<img src="/search.png" />}
            className={styles['search-box']}
            onSearch={handleSearchByKeyWord}
            placeholder={'Search by name or email or skills'}
          />
        </Col>
      </Row>
    </>
  );
};

export default SearchComponent;
